import { LINE_SPACING_TYPE as type } from './types';
export const DEFAULTS = Object.freeze({
  type,
  config: {},
});

export const DEFAULT_LINE_SPACING = {
  'line-height': '1.5',
  'padding-top': '0px',
  'padding-bottom': '0px',
};
